/**
 * Router location state carried across the Focus Groups section so the
 * section's back button can return the user to wherever they entered from
 * (e.g. a Tools page), even after navigating into a report or the new-focus-
 * group flow and back.
 */
export interface FocusGroupsNavState {
  /** Pathname the user entered the Focus Groups section from. */
  from?: string;
}

/** Reads the entry origin recorded in a router location state, if present. */
export const readFocusGroupsOrigin = (state: unknown): string | undefined => {
  const from = (state as FocusGroupsNavState | null)?.from;
  return typeof from === 'string' ? from : undefined;
};

/**
 * `navigate()` options that preserve the entry origin across in-section hops,
 * so deeper pages keep pointing the back button at the original origin.
 */
export const withFocusGroupsOrigin = (from: string | undefined) => ({
  state: { from } satisfies FocusGroupsNavState,
});
